<script>
  export default {
    props: {
      acessoObjeto: {},
      labelsLinguagemSelecionada: {
        type: Object,
        required: true
      },
      labelsDadosLinguagemSelecionada: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
      }
    },
    methods: {
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
    },
  }
</script>

<template>
    
    <div>
        <div class="row" v-if="acessoObjeto.urlDirecionamento || acessoObjeto.instagramCursoEventoDoacao">
            <div class="table-responsive" align='center'>
                <table class="table table-bordered" style="width: auto;">
                    <colgroup>
                        <col style="width: 100px;" v-if="acessoObjeto.urlDirecionamento">
                        <col style="width: 100px;" v-if="acessoObjeto.instagramCursoEventoDoacao">
                    </colgroup>
                    <tbody>
                        <tr>
                            <td style="text-align: center;" v-if="acessoObjeto.urlDirecionamento">
                                <a :href="acessoObjeto.urlDirecionamento" target="_blank">
                                    <img src="img/acesso/atalhos/logo_site.png" alt="Site Oficial" style="width:42px;height:42px;" v-tooltip="'Site Oficial'">
                                </a>
                            </td>
                            <td style="text-align: center;" v-if="acessoObjeto.instagramCursoEventoDoacao">
                                <a :href="acessoObjeto.instagramCursoEventoDoacao" target="_blank">
                                    <img src="img/acesso/atalhos/logo_instagram.png" alt="Instagram" style="width:42px;height:42px;" v-tooltip="'Instagram'">
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="hr-line-dashed" style="margin-top: 0px;" v-if="acessoObjeto.urlDirecionamento || acessoObjeto.instagramCursoEventoDoacao"></div>

        <div class="row" v-if="labelsDadosLinguagemSelecionada.descricaoDoacao">

            <dl class="col-xs-12">
                <dt>{{ this.labelsLinguagemSelecionada.labels.informacoesDoacao }}</dt>
                <dd v-html="nl2br(labelsDadosLinguagemSelecionada.descricaoDoacao)">
                    {{ nl2br(labelsDadosLinguagemSelecionada.descricaoDoacao) }}
                </dd>
            </dl>

        </div>
    </div>
</template>

<style>
  dd, dt {
    letter-spacing: 1.5px;
  }

  div.adicionais dl {
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessoTiposDetalhamentoDoacao.vue